import { BUCKETS } from "@/constants";
import { supabase } from "@/services/supabase/createClient";

export const uploadFileToStorage = async (promptbookId: string, fileId: string, file: File) => {
  const filePath = `${promptbookId}/files/${fileId}`;

  const { data, error } = await supabase.storage.from(BUCKETS.promptbooks).upload(filePath, file, {
    upsert: true,
  });

  if (error) {
    throw error;
  }

  return { fileId, ...data };
};
